import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const STEPS = [
  ['[data-testid="brand-home-btn"]', "Your home base", "Tap the BloomTrack logo anytime to come back to your classes."],
  ['[data-testid="new-class-btn"]', "Create a class", "Start here — make a class, then add your pupils (tick the ASD box where needed)."],
  ['[data-testid="groups-nav-btn"]', "Support groups", "Group pupils across classes for focused support planning."],
  ['[data-testid="nav-meetings-btn"]', "Meetings", "Plan parent or support meetings, draft an agenda with AI, and print the record."],
  ['[data-testid="help-open-btn"]', "Help anytime", "Reopen this guide whenever you need a quick refresher."],
  ['[data-testid="school-settings-btn"]', "School & colleagues", "Add your school details and logo, and invite colleagues."],
];

let cssInjected = false;
function injectCss() {
  if (cssInjected) return;
  cssInjected = true;
  const s = document.createElement("style");
  s.textContent = `
    .driver-popover.bloomtrack-tour{border-radius:16px;font-family:'Outfit',sans-serif}
    .driver-popover.bloomtrack-tour .driver-popover-title{font-family:'Outfit',sans-serif;color:#1e293b}
    .driver-popover.bloomtrack-tour .driver-popover-description{color:#64748b}
    .driver-popover.bloomtrack-tour .driver-popover-next-btn,
    .driver-popover.bloomtrack-tour .driver-popover-done-btn{background:#4A5D6B;color:#fff;text-shadow:none;border:none;border-radius:9999px;padding:6px 16px;font-weight:600}
    .driver-popover.bloomtrack-tour .driver-popover-prev-btn{border-radius:9999px;padding:6px 14px}
  `;
  document.head.appendChild(s);
}

// Starts a short spotlight tour over the real on-screen buttons.
// Only includes steps whose target element is currently in the DOM.
export function startProductTour() {
  injectCss();
  const steps = STEPS
    .filter(([sel]) => document.querySelector(sel))
    .map(([element, title, description]) => ({ element, popover: { title, description, side: "bottom", align: "start" } }));
  if (!steps.length) return;
  driver({
    showProgress: true,
    allowClose: true,
    overlayColor: "#1e293b",
    overlayOpacity: 0.55,
    nextBtnText: "Next",
    prevBtnText: "Back",
    doneBtnText: "Done",
    popoverClass: "bloomtrack-tour",
    steps,
  }).drive();
}
